<template>
  <div class="one-column-view">
    <div class="article-content">
      <div class="d-flex flex-column flex-md-row justify-content-around align-items-center mb-3">
        <div class="w-100 w-md-35 p-0 p-md-3 mb-3">
          <img src="../assets/GSG.png" alt="GSG" class="m-0 mx-auto w-100" />
        </div>
        <div class="w-100 w-md-65 p-0 p-md-3">
          <h1>What is GSG?</h1>
          <p class="m-0">
            Discover the incredible potential of GSG! GSG stands for Gold Strike
            GOLD. This is a traffic mining entry that could grow to high-level
            rewards. With GSG, miners can enjoy a generous 100% direct traffic
            mining reward, an enticing 20% indirect traffic mining reward, and
            an additional 10% event hosting reward. Moreover, GSG offers
            enticing GEMA rewards and the exciting possibility of earning from
            NFT auctions, thereby ensuring a diverse range of income streams for
            miners. Join GSG today and unlock the path to unparalleled earnings!
          </p>
        </div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-around align-items-center mb-3">
        <div class="w-100 w-md-35 p-0 p-md-3 mb-3">
          <img src="../assets/GEMA.png" alt="GSG" class="m-0 mx-auto w-100" />
        </div>
        <div class="w-100 w-md-65 p-0 p-md-3">
          <h1>What is GEMA?</h1>
          <p class="m-0">
            GEMA stands for Global Exclusive Marketing Agent, a prestigious
            privilege granted to GSG. The GEMA certificate is an extension of
            the GSG qualification rights. When you obtain the GSG entry and
            refer businesses to GoldenLink+, you become the marketing agent of
            the company (i.e., the mine owner or advertiser) on the GOLD
            platform, and you will enjoy the exclusive privilege of using the
            powerful GoldenLink+ application to increase business sales. This
            certification not only guarantees unparalleled support but also
            opens up numerous growth opportunities for the GSG: building social
            media connections, growing influence, and increasing traffic
            conversion.
          </p>
        </div>
      </div>
      <h1>GSG and GEMA Certificates</h1>
      <p>
        This advanced level entry on the GoldenLink+ platform offers commercial
        marketing monetization qualifications and reward algorithm functions for
        Goldenlik+ users. The GSG or GEMA certificate holders can enjoy
        additional benefits compared to GSR by actively promoting products,
        services, and brands, and improving traffic mining capabilities.
      </p>
      <h1>NFT Token Function Transfer and Auction</h1>
      <p>
        The transfer of ownership for GSG and GEMA certificates can now be done
        through a bidding auction or an online exchange market. GoldenLink+ has
        innovatively expanded the traditional certificate qualifications to NFT
        tokens, allowing for seamless conversion into an online web3 NFT token
        auction or transaction transfer model. By purchasing NFT tokens (GSG or
        GEMA), holders of these certificates can easily transfer or auction
        their qualifications by linking them to the tokens on the platform.
      </p>
      <h1>Why Auction?</h1>
      <p>
        In the world of business, the traditional model allows companies to sell
        or auction their marketing rights. GoldenLink+ is a social media
        platform that provides businesses with the opportunity to transfer or
        auction their marketing qualifications for certain benefits in the
        online community.
      </p>
      <h1>Get Greater Benefits</h1>
      <p>
        Link your GSG or GEMA certificate qualifications to GSG or GEMA NFT
        tokens, and take advantage of the opportunity to transfer or auction
        your qualifications for even greater benefits.
      </p>
      <h1>Other Profit Methods</h1>
      <p>
        If you're not looking to transfer qualification benefits using binding
        certificates and NFT tokens, you can leverage your influence within the
        community to build a strong following for your brand, product, or
        service. Share the marketing dividends with active participants,
        negotiate for better rewards from companies as a marketing leader,
        invite more members to join your community, and put in the effort to
        drive successful marketing conversions. Depending on their goals,
        participants can earn share dividends or marketing rewards.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
